import { render } from "./P068.vue?vue&type=template&id=19890dff&scoped=true"
import script from "./P068.vue?vue&type=script&lang=js"
export * from "./P068.vue?vue&type=script&lang=js"

import "./P068.vue?vue&type=style&index=0&id=19890dff&scoped=true&lang=css"

import exportComponent from "/home/sage/workspace/sageprice-dev/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-19890dff"]])

export default __exports__